import React, { useContext, useState } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Form, Input, Button, Checkbox } from 'antd'
import { AuthContext } from '../../Providers/AuthProvider'
import { lookup } from '../../utils/api/auth'
import { HttpStatuses } from '../../utils/http'
import { faInfoCircle } from '@fortawesome/pro-duotone-svg-icons'
import { ColorsPalette } from '../../config/colors'
import { useSelector } from 'react-redux'
import { selectTranslate } from '../../reducers/LocaleReducer/LocalReducer'

import '../../assets/shared/modal-inner-container.scss'

const FormItem = Form.Item

const LoginForm = ({ onLogin, loginPending, onPasswordResetClick, form }) => {
  const { redirectToSSOLoginPage } = useContext(AuthContext)

  const t = useSelector(selectTranslate)

  const [isLocalAccount, setIsLocalAccount] = useState(false)
  const [displayForgotPassword, setDisplayForgotPassword] = useState(false)

  const handleSubmit = (e) => {
    e.preventDefault()
    form.validateFields(async (err, values) => {
      if (!isLocalAccount) {
        setDisplayForgotPassword(false)

        const response = await lookup(values.username)
          .catch(error => {
            setDisplayForgotPassword(true)

            if (error.status === HttpStatuses.NOT_FOUND) {
              form.setFields({
                username: {
                  value: values.username,
                  errors: [new Error(t('login_lookup.error.404'))]
                }
              })
            } else {
              form.setFields({
                username: {
                  value: values.username,
                  errors: [new Error(t('An unknown error has occured.'))]
                }
              })
            }
          })

        if (response) {
          response.isExternal ? redirectToSSOLoginPage(values.username) : setIsLocalAccount(true)
        }
      } else if (!err && values.username.length > 0 && values.password && values.password.length > 0) {
        onLogin(values)
      }
    })
  }

  const handleForgotPassword = (e) => {
    e.preventDefault()
    onPasswordResetClick()
  }

  const handleEmailChange = () => {
    setIsLocalAccount(false)
  }

  const { getFieldDecorator } = form

  return (
    <Form onSubmit={handleSubmit} className='login-form h-100-i'>
      <div className='flex-col h-100'>
        <div className='labels'>
          <div className='title'>{t('Internships management')}</div>

          <div style={{ textAlign: 'center' }}>
            {t('nurses')}&nbsp;
            <span>-</span>&nbsp;{t('doctors')}&nbsp;
            <span>-</span>&nbsp;{t('paramedics')}&nbsp;
            <span>-</span>&nbsp;{t('midwifes')}
          </div>
        </div>
        <div className='flex-fill' />
        <FormItem style={{ marginBottom: '10px' }}>
          <label>{t('Email address')}</label>
          {getFieldDecorator('username', { rules: [{ required: true, message: t('login_email_missing') }] })(
            <Input prefix={<FontAwesomeIcon icon='user' />} placeholder={t('Email address')} onChange={handleEmailChange} />
          )}
        </FormItem>
        {isLocalAccount && (
          <>
            <FormItem style={{ marginBottom: '10px' }}>
              <label>{t('Password')}</label>
              {getFieldDecorator('password', { rules: [] })(
                <Input prefix={<FontAwesomeIcon icon='lock' />} type='password' placeholder={t('Password')} />
              )}
            </FormItem>
            <a href='#/' onClick={handleForgotPassword} className='forgot-password-link'>{t('Forgotten password ?')}</a>
          </>
        )}
        {displayForgotPassword && (
          <div className='modal-inner-container warning'>
            <div className='flex-row ai-bl'>
              <FontAwesomeIcon
                icon={faInfoCircle}
                color={ColorsPalette.WARNING_FONT}
              />
              <span className='pdl-4'><strong>{t('login_form.forgotten_password.message')}</strong></span>
            </div>
            <div>
              <span>
                <a href='#/' onClick={handleForgotPassword} className='forgot-password-link'>{t('login_send_account_finalization_email')}</a>
              </span>
            </div>
          </div>
        )}

        <div className='flex-fill' />

        <div className='mt-12'>
          <a className='useful-link' href='https://opalsolutions.zendesk.com/hc/fr/categories/360003066859-Comment-utiliser-Interneo-'>F.A.Q.</a>
          {t('and')}&nbsp;
          <a className='useful-link' href='https://www.youtube.com/channel/UCdF4BK3XhULkd3809NHp5pw/featured'>{t('video')}</a>
        </div>

        {isLocalAccount && (
          <div className='sign-in-wrapper'>
            <FormItem>
              {getFieldDecorator('remember', { valuePropName: 'checked', initialValue: true })(
                <Checkbox><span className='remember-text'>{t('Remember me')}</span></Checkbox>
              )}
            </FormItem>
          </div>
        )}
        <div className='sign-in-wrapper' style={{ position: 'relative' }}>
          <Button type='primary' htmlType='submit' className='login-button' loading={loginPending}>
            {isLocalAccount ? t('Log in') : t('Next')}
          </Button>

          <img src='/assets/opal-logo.png' className='opal-logo-form' />
        </div>
      </div>
    </Form>
  )
}

export default Form.create()(LoginForm)
